import {
  SET_SHOW_HEADER,
  SET_SHOW_FOOTER,

  SET_SLOGAN,
  SET_BACKLINK,
  SET_CURRENT_TITLE,
  SET_MENU,
  SET_MENU_SHOW,
  SET_MENU_VALUE,

  LOAD_EVENT_INFO,
  LOAD_EVENT_INFO_SUCCESS,
  LOAD_EVENT_INFO_FAIL,
} from "cityads-v3/actions/header";

import {
  GET_LAYOUT_DATA_SUCCESS
} from 'cityads-v3/actions/menu';

const initialState = {
  showHeader: true,
  showFooter: true,

  slogan: null,
  backlink: null,
  backlinkText: null,
  bar: [],
  title: null,
  menu: [],
  menuShow: false,
  menuValue: false,

  events: {
    eventById: {}
  }
};

export default function header(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SHOW_HEADER:
      return {
        ...state,
        showHeader: action.showHeader,
      };

    case SET_SHOW_FOOTER:
      return {
        ...state,
        showFooter: action.showFooter,
      };

    case SET_SLOGAN:
      return {
        ...state,
        slogan: action.slogan,
      };

    case SET_BACKLINK:
      return {
        ...state,
        backlink: action.link,
        backlinkText: action.text,
      };

    case SET_CURRENT_TITLE:
      return {
        ...state,
        title: action.title,
      };

    case SET_MENU_VALUE:
      return {
        ...state,
        menuValue: action.menuValue
      };

    case SET_MENU_SHOW:
      return {
        ...state,
        menuShow: action.menuShow
      };

    case SET_MENU:
      return {
        ...state,
        menu: [
          ...(action.menu ?? [])
        ]
      }

    case GET_LAYOUT_DATA_SUCCESS:
      return {
        ...state,
        bar: action.response.data.header.bar,
        manager: action.response.manager,
        needDocumentForPayment: action.response.needDocumentForPayment,
        user: action.response.user || {},
      };

    case LOAD_EVENT_INFO:
      return {
        ...state,
        events: {
          ...state.events,
          ['isLoadingEvent_' + action.additional.id]: true,
        }
      };

    case LOAD_EVENT_INFO_SUCCESS:
      return {
        ...state,
        events: {
          ...state.events,
          ['isLoadingEvent_' + action.additional.id]: false,
          eventById: {
            ...state.events.eventById,
            [action.additional.id]: action.response
          }
        }
      };

    case LOAD_EVENT_INFO_FAIL:
      return {
        ...state,
        events: {
          ...state.events,
          ['isLoadingEvent_' + action.additional.id]: false,
        }
      };

    default:
      return state;
  }
}

export function getIsHeaderNavDisplayed({ title, menuShow, menu, backlink }) {
  return Boolean(
    title ||
    (menuShow && menu && menu.length) ||
    backlink
  );
}

export function selectIsHeaderNavDisplayed(state) {
  return getIsHeaderNavDisplayed({
    title: state.header.title,
    menuShow: state.header.menuShow,
    menu: state.header.menu,
    backlink: state.header.backlink,
  });
}
